import { type MCPServerInfo } from '../../types';

const ChromeDevtoolsServer: MCPServerInfo = {
  serverId: 'CHROME_DEVTOOLS',
  name: 'Chrome DevTools',
  slug: 'chrome-devtools',
  description:
    'Use Chrome DevTools to control your chrome browser instance locally',
  source: {
    sourceType: 'LOCAL_PACKAGE',
    transport: 'STDIO',
    commandFunction: `(config) => {
      const args = ['-y', 'chrome-devtools-mcp@latest', '--no-usage-statistics'];
      
      if (config.channel) {
        args.push('--channel', config.channel.toLowerCase());
      }

      return {
        command: 'npx',
        args,
        env: {}
      }
    }`
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {
      channel: {
        type: 'string',
        description:
          'Chrome channel type to use (options: stable/canary/beta/dev)',
        sensitive: false,
        default: 'stable'
      }
    }
  }
};

export default ChromeDevtoolsServer;
